// src/components/admin/AdminUsers.jsx
import React, { useEffect, useState } from "react";
import { useAdminApi } from "../../admin/adminApi";

const AdminUsers = () => {
  const { getJson, postJson } = useAdminApi();
  const [users, setUsers] = useState([]);
  const [error, setError] = useState("");

  const load = async () => {
    try {
      setError("");
      const data = await getJson("/api/users");
      setUsers(data.users || []);
    } catch (e) {
      console.error("[ADMIN] Users error:", e);
      setError("Failed to load users");
    }
  };

  const kick = async (emailId) => {
    if (!window.confirm(`Kick ${emailId}?`)) return;
    try {
      await postJson("/api/users/" + encodeURIComponent(emailId) + "/kick");
      load();
    } catch (e) {
      console.error("[ADMIN] Kick error:", e);
      alert("Failed to kick user");
    }
  };

  useEffect(() => {
    load();
    const id = setInterval(load, 5000);
    return () => clearInterval(id);
  }, []);

  return (
    <div
      style={{
        borderRadius: 16,
        padding: 12,
        background:
          "linear-gradient(135deg, rgba(15,23,42,0.97), rgba(15,23,42,1))",
        border: "1px solid rgba(148,163,184,0.35)",
      }}
    >
      <div
        style={{
          fontSize: 13,
          fontWeight: 600,
          marginBottom: 8,
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <span>Connected Users ({users.length})</span>
        <button
          onClick={load}
          style={{
            fontSize: 11,
            borderRadius: 999,
            border: "1px solid rgba(148,163,184,0.6)",
            padding: "2px 8px",
            background: "rgba(15,23,42,0.9)",
            color: "#e5e7eb",
            cursor: "pointer",
          }}
        >
          Refresh
        </button>
      </div>

      {error && (
        <div style={{ fontSize: 11, color: "#f97373" }}>{error}</div>
      )}

      {users.length === 0 && !error && (
        <div style={{ fontSize: 12, color: "#9ca3af" }}>
          No connected users.
        </div>
      )}

      {users.length > 0 && (
        <div
          style={{
            maxHeight: 260,
            overflowY: "auto",
            fontSize: 12,
            display: "flex",
            flexDirection: "column",
            gap: 8,
          }}
        >
          {users.map((u) => (
            <div
              key={u.socketId}
              style={{
                padding: 8,
                borderRadius: 10,
                border: "1px solid rgba(55,65,81,0.9)",
                background: "rgba(15,23,42,0.9)",
                display: "flex",
                justifyContent: "space-between",
                gap: 8,
                alignItems: "center",
              }}
            >
              <div>
                <div style={{ fontSize: 12, fontWeight: 500 }}>
                  {u.emailId || "(no email)"}
                </div>
                <div style={{ fontSize: 11, color: "#9ca3af" }}>
                  Room: {u.roomId || "-"}
                </div>
                <div style={{ fontSize: 10, color: "#6b7280" }}>
                  Socket: {u.socketId}
                </div>
              </div>
              <button
                onClick={() => kick(u.emailId)}
                style={{
                  fontSize: 11,
                  borderRadius: 999,
                  border: "1px solid rgba(248,113,113,0.85)",
                  padding: "4px 10px",
                  background: "linear-gradient(135deg, #ef4444, #b91c1c)",
                  color: "#f9fafb",
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                }}
              >
                Kick
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminUsers;
